import UIButton from 'UIComponents/button/UIButton';
import UIAlert from 'UIComponents/alert/UIAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UpdateFilterWithExternalOptionsNotification = ({
  onUpdateClick,
  canFilterBeConverted
}) => {
  return /*#__PURE__*/_jsx(View, {
    marginBlockStart: "250",
    children: /*#__PURE__*/_jsxs(UIAlert, {
      "data-test-id": "update-filter-with-external-options-notification",
      className: "p-x-2",
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "newCustomerDataFilters.externalOptionsFilterUpdate.title"
      }),
      type: "tip",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "newCustomerDataFilters.externalOptionsFilterUpdate.text"
      }), !canFilterBeConverted && /*#__PURE__*/_jsx(UIAlert, {
        "data-test-id": "update-filter-with-external-options-warning",
        type: "warning",
        className: "m-top-2 p-x-2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "newCustomerDataFilters.externalOptionsFilterUpdate.warning"
        })
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(UIButton, {
          "data-test-id": "update-filter-with-external-options-button",
          className: "p-left-0",
          use: "transparent",
          onClick: onUpdateClick,
          responsive: false,
          disabled: !canFilterBeConverted,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "newCustomerDataFilters.externalOptionsFilterUpdate.action"
          })
        })
      })]
    })
  });
};
export default UpdateFilterWithExternalOptionsNotification;